import {stringify} from 'querystring';
export async function requestPost(baseURL, url, params) {
    return fetch(baseURL + url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: stringify(params)
    }).then(response => response.json());
}

export async function requestGet(baseURL, url, params) {
    return fetch(baseURL + url +'?'+ stringify(params)).then(response => response.json());
}